import { create } from "zustand";
import { persist } from "zustand/middleware";
import { CurrentUser } from "@/lib/api/client";
import { endLoginSession, startLoginSession } from "@/lib/login-session";
import { clearPendingLoginReturn } from "@/lib/safe-redirect";

interface AuthState {
  isAuthenticated: boolean;
  user: CurrentUser | null;
  setAuth: (user: CurrentUser, accessToken: string, refreshToken: string) => void;
  logout: () => void;
  updateUser: (user: Partial<CurrentUser>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,

      setAuth: (user, accessToken, refreshToken) => {
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem("refresh_token", refreshToken);
        // A new login: once-per-login things (the guide popup) happen again.
        startLoginSession();
        set({ isAuthenticated: true, user });
      },

      logout: () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        endLoginSession();
        // The page they were headed to belongs to the login that just ended.
        clearPendingLoginReturn();
        set({ isAuthenticated: false, user: null });
      },
      
      updateUser: (userData) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        })),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user,
      }),
    }
  )
);
